import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enGBLanguage from "./assets/translations/en-GB/common-en.json";
import enUSLanguage from "./assets/translations/en-US/common-en.json";

const namespaceName = "translations";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      "en-US": { translations: enUSLanguage },
      "en-GB": { translations: enGBLanguage },
      en: { translations: enGBLanguage },
    },
    fallbackLng: "en",
    debug: false,
    ns: [namespaceName],
    defaultNS: namespaceName,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export const tCommon = { ns: namespaceName };
export default i18n;
